import React from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import { transferencias, formatearFecha, nombreTienda } from '../data';

const ESTADO_COLORS = { completada: 'success', enviada: 'info', pendiente: 'warning', cancelada: 'error' };

function Transfers() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Transferencias</Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Folio</TableCell>
              <TableCell>Origen → Destino</TableCell>
              <TableCell>Productos</TableCell>
              <TableCell>Solicita</TableCell>
              <TableCell>Autoriza</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell align="center">Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transferencias.map(t => (
              <TableRow key={t._id} hover>
                <TableCell sx={{ fontFamily: 'monospace', fontWeight: 600 }}>{t.folio}</TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Chip label={nombreTienda(t.tienda_origen)} size="small" />
                    <Typography variant="caption">→</Typography>
                    <Chip label={nombreTienda(t.tienda_destino)} size="small" />
                  </Box>
                </TableCell>
                <TableCell>
                  {t.productos.map((p, i) => (
                    <Typography key={i} variant="body2">{p.nombre} ({p.cantidad_solicitada} uds)</Typography>
                  ))}
                </TableCell>
                <TableCell>{t.usr_solicita}</TableCell>
                <TableCell>{t.usr_autoriza}</TableCell>
                <TableCell>{formatearFecha(t.createdAt)}</TableCell>
                <TableCell align="center">
                  <Chip label={t.estado} size="small" color={ESTADO_COLORS[t.estado]} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Transfers;
